<template>
  <v-main>

    <v-container
        id="claim-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-bank-transfer-in"
          class="px-5 py-3"
          ref="form"
      >

        <div class="page-messages">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>

          <p>Please only submit one Claim per occurrence.</p>
        </div>

        <v-form ref="claimForm"
                v-model="valid"
                @submit.prevent="validate"
                lazy-validation
        >

          <v-row>
            <v-col
                cols="12"
                sm="6"
            >
              <v-combobox
                  v-model="computedUser"
                  label="Member"
                  placeholder="Start typing to search"
                  :items="computedUserList"
                  :loading="isLoadingUsers"
                  :search-input.sync="memberSearchString"
                  item-text="names"
                  item-value="id"
                  return-object
                  persistent-placeholder
                  no-filter
                  validate-on-blur
                  @input.native="computedUser=$event.srcElement.value"
                  :rules="rules.validateMember"
              ></v-combobox>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="6"
            >
              <v-select
                  v-model="computedDependent"
                  label="Dependent"
                  :items="dependentList"
                  item-text="names"
                  item-value="id"
                  return-object
                  :rules="rules.required"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="9"
            >
              <v-text-field
                  v-model="claim.cause"
                  label="Cause of Death"
                  :rules="rules.required"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="6"
            >
              <v-combobox
                  ref="verifiedBy"
                  v-model="claim.verifiedBy"
                  label="Verified by Member"
                  placeholder="Start typing to search"
                  :items="computedVerifierList"
                  :loading="isLoadingVerifiers"
                  :search-input.sync="verifierSearchString"
                  item-text="names"
                  item-value="id"
                  return-object
                  persistent-placeholder
                  no-filter
                  validate-on-blur
                  @input.native="computedVerifier=$event.srcElement.value"
                  :rules="rules.validateVerifier"
              ></v-combobox>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="9"
            >
              <v-textarea
                  v-model="claim.notes"
                  label="Notes"
                  rows="1"
              ></v-textarea>
            </v-col>

          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="3"
            >
              <v-text-field
                  v-model="computedIncidentDate"
                  label="Incident Date"
                  type="date"
                  :rules="rules.required"
              ></v-text-field>
            </v-col>

          </v-row>


          <v-row>
            <v-col
                cols="12"
                sm="3"
            >
              <v-text-field
                  v-model="computedPaymentDate"
                  label="Payment Date"
                  type="date"
                  :rules="rules.validatePaymentDate"
              ></v-text-field>
            </v-col>

            <v-col
                cols="12"
                sm="3"
            >
              <v-text-field
                  v-model="claim.paymentAmount"
                  label="Payment Amount"
                  :rules="rules.validatePaymentAmount"
              ></v-text-field>
            </v-col>

            <v-col
                cols="12"
                sm="3"
            >
              <v-text-field
                  v-model="claim.paymentMethod"
                  label="Payment Method"
                  :rules="rules.validatePaymentMethod"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="3"
            >
              <v-select
                  v-model="claim.status"
                  label="Status"
                  :items="computedClaimStatusItems"
                  item-text="text"
                  item-value="value"
                  @change="runValidateVerifierByStatus"
                  :rules="rules.required"
              ></v-select>
            </v-col>

            <v-col
                cols="12"
                sm="6"
            >
              <v-text-field
                  v-model="comment"
                  label="Comment"
              ></v-text-field>
            </v-col>
          </v-row>


          <v-row>
            <v-col
                cols="12"
                sm="6"
            >
              <div>
                <v-btn
                    color="primary"
                    dark
                    type="submit"
                >
                  Submit
                </v-btn>

                <v-btn
                    color="red"
                    dark
                    type="button"
                    @click="confirmDeleteClaim"
                >
                  Delete
                </v-btn>
              </div>
            </v-col>
          </v-row>

                    <v-dialog
                        v-model="showDeleteDialog"
                        max-width="400"
                    >
                      <template v-slot:default="dialog">
                        <v-card>
                          <v-card-text>
                            Are you sure you want to delete this claim?
                          </v-card-text>
                          <v-card-actions  class="justify-center">
                              <v-btn
                                  type="button"
                                  color="primary"
                                  dark
                                  @click="dialog.value = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                  type="button"
                                  color="red"
                                  dark
                                  @click="deleteClaim"
                              >
                                Delete
                              </v-btn>
                          </v-card-actions>
                        </v-card>
                      </template>
                    </v-dialog>



        </v-form>


      </base-material-card>


      <v-expansion-panels
          multiple
          light
          hover
          v-model="expandedPanels"
          v-if="claim.id"
      >
        <v-expansion-panel>
          <v-expansion-panel-header>Audit Trail</v-expansion-panel-header>

          <v-expansion-panel-content>
            <shared-audit-trail-view :item-id="claim.id"></shared-audit-trail-view>
          </v-expansion-panel-content>

        </v-expansion-panel>
      </v-expansion-panels>

    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import validation from "@/utils/validation"
import moment from "moment";
import constants from "@/utils/constants";
import SharedAuditTrailView from "../shared/AuditTrailView";
import SharedPageMessages from '../shared/PageMessages.vue'

export default {
  name: 'CoreClaimView',
  components: {SharedPageMessages, SharedAuditTrailView},

  created() {
    this.claim.id = this.$route.params.claimId
    this.claim.user.id = this.$route.params.memberId

    if (this.claim.id !== undefined && this.claim.user.id !== undefined) {
      this.fetchClaim()
    }
  },

  watch: {
    memberSearchString(val) {
      if (!this.isLoadingUsers && val !== null && (val.length > 2)) {
        this.searchUsers(val)
      }
    },
    verifierSearchString(val) {
      if (!this.isLoadingVerifiers && val !== null && (val.length > 2)) {
        this.searchVerifiers(val)
      }
    },
    computedUser(val) {
      this.fetchDependents()
    }
  },

  computed: {
    computedClaimStatusItems: {
      get: function () {
        return Object.keys(this.claimStatusMap)
            .map((key) => ({value: key, text: this.claimStatusMap[key]}))
      }
    },
    computedDependent: {
      get() {
        if (this.claim.dependent.id === undefined || this.claim.dependent.id == null) {
          return
        }
        return this.dependentList.find(dep => this.claim.dependent.id === dep.id)
      },
      set(value) {
        this.claim.dependent = value
      }
    },
    computedUser: {
      get() {
        if (this.claim.user.id === undefined || this.claim.user.id === null) {
          return null
        }
        return {
          id: this.claim.user.id,
          names: this.claim.user.names
        }
      },
      set(value) {
        this.claim.user = value
      }
    },
    computedVerifier: {
      get() {
        return {
          id: this.claim.verifiedBy.id,
          names: this.claim.verifiedBy.names
        }
      },
      set(value) {
        this.claim.verifiedBy = value
      }
    },
    dependentList: {
      get() {
        return this.dependents
            .filter(dep => !(this.claim.id === undefined && dep.status !== constants.DEPENDENT_STATUS_APPROVED))
            .map(dep => ({ id: dep.id, names: `${dep.names} (${dep.relationType.name})` }))
      }
    },
    computedUserList: {
      get() {
        return this.users.map(u => ({ id: u.id, names: u.names}))
      }
    },
    computedVerifierList: {
      get() {
        return this.verifiers
            .filter((v) => v.id !== this.claim.user.id)
            .map(v => ({ id: v.id, names: v.names }))
      }
    },
    computedIncidentDate: {
      get() {
        return moment(this.claim.incidentDate).format('YYYY-MM-DD')
      },
      set(value) {
        this.claim.incidentDate = value
      }
    },
    computedPaymentDate: {
      get() {
        if (this.claim.paymentDate == null) {
          return
        }
        return moment(this.claim.paymentDate).format('YYYY-MM-DD')
      },
      set(value) {
        this.claim.paymentDate = value
      }
    },
    computedRequireVerifier() {
      return this.claim.status === constants.CLAIM_STATUS_VERIFIED
    },
    computedRequirePaymentDetails() {
      return this.claim.status === constants.CLAIM_STATUS_PAID
    }
  },

  methods: {
    clearMessages() {
      this.errorMessages = []
      this.warningMessages = []
      this.successMessages = []
    },
    confirmDeleteClaim() {
      this.showDeleteDialog = true
    },
    validate() {
      this.clearMessages()
      if(this.$refs.claimForm.validate()) {
        if (this.claim.id !== undefined && this.claim.id !== null) {
          return this.updateClaim()
        }
        this.addClaim()
      }
    },
    runValidateVerifierByStatus() {
      this.$refs.claimForm.validate('verifiedBy')
    },
    searchUsers(val) {
      this.isLoadingUsers = true
      this.fetchUsers(val)
          .then(result => {
            this.users = result
            this.isLoadingUsers = false
        })
    },
    searchVerifiers(val) {
      this.isLoadingVerifiers = true
      this.fetchUsers(val)
          .then(result => {
            this.verifiers = result
            this.isLoadingVerifiers = false
          })
    },
    fetchUsers(val) {
      this.clearMessages()
      let nameParts = val.split(' ')
      let firstPart = nameParts.shift()
      let lastPart = nameParts.pop() || firstPart
      let filters = {
        firstName: firstPart,
        lastName: lastPart,
        searchCondition: 'OR'
      }
      return api.fetchUsers(filters)
          .then(response => {
            return response.data.content
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    fetchDependents() {
      this.clearMessages()
      api.fetchDependents(this.claim.user.id)
          .then(response => {
            this.dependents = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    fetchClaim() {
      this.clearMessages()
      api.fetchClaim(this.claim.user.id, this.claim.id)
          .then(response => {
            this.claim = response.data
            this.searchUsers(this.claim.user.names)
            if (this.claim.verifiedBy !== null) {
              this.searchVerifiers(this.claim.verifiedBy.names)
            }
            this.fetchDependents()
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    addClaim() {
      this.clearMessages()
      let payload = this.buildPayload()
      api.addClaim(this.claim.user.id, payload)
          .then(response => {
            if (response.status === 201) {
              this.$router.push(`/claims`)
            }
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    updateClaim() {
      this.clearMessages()
      let payload = this.buildPayload()
      api.updateClaim(this.claim.user.id, this.claim.id, payload)
          .then(response => {
            if (response.status === 200) {
              this.$router.push('/claims')
            }
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    deleteClaim() {
      this.clearMessages()
      api.deleteClaim(this.claim.user.id, this.claim.id)
          .then(response => {
            if (response.status === 204) {
              this.$router.push('/claims')
            }
          })
          .catch(err => {
            this.handleError(err)
          })
    },

    buildPayload() {
      let payload = {
        dependentId: this.claim.dependent.id,
        incidentDate: moment(this.claim.incidentDate).format('YYYY-MM-DD'),
        cause: this.claim.cause,
        notes: this.claim.notes,
        paymentAmount: this.claim.paymentAmount,
        paymentMethod: this.claim.paymentMethod,
        status: this.claim.status,
        comment: this.comment
      }

      if (this.claim.paymentDate) {
        payload.paymentDate = moment(this.claim.paymentDate).format('YYYY-MM-DD')
      }

      if (this.claim.verifiedBy !== undefined && this.claim.verifiedBy !== null) {
        payload.verifiedByUserId = this.claim.verifiedBy.id
      }

      return payload
    },

    handleError(err) {
      let errorMessage = api.parseResponseError(err)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      valid: true,
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      userId: null,
      claimId: null,
      cause: null,
      user: {},
      claim: {
        id: null,
        user: {
          id: null,
          names: null,
        },
        dependent: {},
        verifiedBy: {
          id: null,
          names: null,
        },
        status: null
      },
      dependents: [],
      users: [],
      verifiers: [],
      comment: null,
      memberSearchString: '',
      verifierSearchString: '',
      isLoadingUsers: false,
      isLoadingVerifiers: false,
      showDeleteDialog: false,
      claimStatusMap: constants.getClaimStatusMap(),
      expandedPanels: [0],
      rules: {
        required: [
          v => validation.isRequired(v) || 'required'
        ],
        numeric: [
          v => validation.isInteger(v) || 'must be a number'
        ],
        birthYear: [
          v => validation.isInteger(v) || 'must be a year number',
          v => validation.isMoreThan(v, 1900) || 'must be after 1900',
          v => validation.isBeforeOrEqualToCurrentYear(v) || 'must be before or equal to current year'
        ],
        validateMember: [
          v => validation.isRequired(v) || 'required',
          v => validation.isContainedInObjectsList(v, this.computedUserList) || 'must be in the list of members'
        ],
        validateVerifier: [
          v => (!this.computedRequireVerifier || validation.isRequired(v)) || 'required if the claim status is "Verified"',
          v => validation.isContainedInObjectsList(v, this.computedVerifierList, true) || 'must be in the list of members'
        ],
        validatePaymentDate: [
          v => (!this.computedRequirePaymentDetails || validation.isRequired(v)) || 'required if the claim status is "Paid"'
        ],
        validatePaymentAmount: [
          v => (!this.computedRequirePaymentDetails || validation.isRequired(v)) || 'required if the claim status is "Paid"',
          v => validation.isOptionalCurrency(v) || 'must be in currency format XXXX.XX'
        ],
        validatePaymentMethod: [
          v => (!this.computedRequirePaymentDetails || validation.isRequired(v)) || 'required if the claim status is "Paid"'
        ]
      }
    }
  }
}
</script>


<style scoped lang="scss">
</style>
